var _defs, _path, _path2, _circle, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:#fff;}.cls-1,.cls-2,.cls-3,.cls-4{stroke:#000;stroke-miterlimit:10;}.cls-2,.cls-3{fill:none;}.cls-3,.cls-4{stroke-linecap:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.57,293.35a18.8,18.8,0,0,0,5.57,4.68,8.66,8.66,0,0,0,7.08.52c4.33-1.81,5.53-7.52,4.65-12.12s-3.19-8.89-3.57-13.56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.75,277.67c-.46,3.94-.92,7.95-.18,11.84s2.9,7.72,6.44,9.49,8.51.84,10.44-2.62"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 107.7,
    cy: 260.95,
    r: 40.68
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.38,269.26a64.21,64.21,0,0,0,40.47-49.53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.71,251.17c14.72,12.89,37,16.41,55,8.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.63,262.63c-.62,7.91-.82,12.4-.8,20.1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.31,
    cy: 275.76,
    rx: 4.9,
    ry: 3.68,
    transform: "translate(-189.16 348.86) rotate(-86.05)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.99,
    cy: 277.54,
    rx: 4.9,
    ry: 3.68,
    transform: "translate(-167.02 376.13) rotate(-86.05)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.33,280.8a1.45,1.45,0,0,0-1.68.8c-.34.9.57,1.76,1.41,2.24A7.56,7.56,0,0,0,91.28,285a5.11,5.11,0,0,0,3.15-.57,1.11,1.11,0,0,0-.32-2c-.48-.21-1.54.34-3,0S89.72,281.15,88.33,280.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.94,283.94c1.38-.39,2.15-2.17,3.8-1.86,1.43.26,1.23,2.22-1.14,3.52a7.4,7.4,0,0,1-5.39.89c-.76-.21-2.53-1.26-1.95-2.57C115,282.34,116.37,284.66,118.94,283.94Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.88,291.81a24.79,24.79,0,0,1,14.9.81"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.84,323.91a43.81,43.81,0,0,1,10.5-31.21,16.4,16.4,0,0,1,4.6-3.95,7.38,7.38,0,0,1,5.89-.6c3.25,1.22,4.71,5.25,4.14,8.68s-2.65,6.38-4.67,9.21a8.51,8.51,0,0,1,3-3.12c1.29-.66,3.13-.47,3.85.78a3.06,3.06,0,0,1-.92,3.63,13.91,13.91,0,0,1-3.56,1.93,17.51,17.51,0,0,0-9.42,18.92"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.37,330.64a20.29,20.29,0,0,0-4.88-19.1,13.32,13.32,0,0,1-2.78-3.32c-.62-1.32-.51-3.13.7-3.94a3,3,0,0,1,2.91,0,9.1,9.1,0,0,1,2.36,1.88A9.77,9.77,0,0,1,114.5,297a7.63,7.63,0,0,1,7.27-5.93c2.51.08,4.76,1.57,6.56,3.32,4.94,4.81,7.38,11.81,7.59,18.7s-1.61,13.72-4.19,20.11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel6);
export default __webpack_public_path__ + "static/media/Idea_Panel_6.fb1659a2148f85cd2d3a2bfc22443a7e.svg";
export { ForwardRef as ReactComponent };